import { render, staticRenderFns } from "./MobileRecrutamentoComponent.vue?vue&type=template&id=803f16ca&lang=pug&"
var script = {}
import style0 from "./MobileRecrutamentoComponent.vue?vue&type=style&index=0&id=803f16ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports